import { useNavigate } from 'react-router-dom';
import './Pages.css';

export default function TermsAndConditions() {
  const navigate = useNavigate();

  return (
    <div className="page-wrap" style={{ alignItems: 'flex-start', padding: '40px 20px' }}>
      <div style={{ maxWidth: 760, margin: '0 auto', width: '100%' }}>

        {/* Header */}
        <div style={{ marginBottom: 32 }}>
          <div
            className="logo"
            style={{ fontSize: 22, marginBottom: 16, cursor: 'pointer' }}
            onClick={() => navigate('/')}
          >
            <span className="logo-r">R</span>esumify
          </div>
          <h1 style={{ fontSize: 28, fontWeight: 700, marginBottom: 8 }}>Terms and Conditions</h1>
          <p style={{ color: 'var(--text-muted)', fontSize: 14 }}>
            Last updated: 30 March 2026
          </p>
        </div>

        <div className="terms-body">

          <section>
            <h2>1. About Resumify</h2>
            <p>
              Resumify ("we", "us", "our") is an AI-powered CV tailoring service operated by Mogomotsi Morwa,
              a sole proprietor based in South Africa. Our service is available at{' '}
              <a href="https://www.resumify.co.za">www.resumify.co.za</a>.
            </p>
            <p>
              By using Resumify, you ("the user") agree to these Terms and Conditions in full.
              If you do not agree, please do not use our service.
            </p>
          </section>

          <section>
            <h2>2. The Service</h2>
            <p>
              Resumify uses artificial intelligence to tailor your CV to a specific job description.
              The service processes your uploaded CV and job description through a 5-step AI pipeline
              and produces a tailored CV in DOCX format.
            </p>
            <p>
              Our service includes an automated integrity audit that verifies no fabricated information
              has been added to your CV. However, you remain solely responsible for reviewing and
              verifying the accuracy of all content in your tailored CV before submitting it to
              any employer.
            </p>
          </section>

          <section>
            <h2>3. Pricing and Payment</h2>
            <p>
              Your first CV tailor is provided free of charge. Each subsequent tailor costs
              R25.00 (South African Rand), payable via PayFast before the tailored CV is downloaded.
            </p>
            <p>
              All payments are processed securely by PayFast (Pty) Ltd. Resumify does not store
              your card details. Payments are non-refundable once the CV has been generated and
              the download link has been made available.
            </p>
            <p>
              Prices are inclusive of VAT where applicable and are subject to change with reasonable notice.
            </p>
          </section>

          <section>
            <h2>4. Refund Policy</h2>
            <p>
              Due to the digital nature of our service, we do not offer refunds once a tailored CV
              has been successfully generated and made available for download. If you experience a
              technical failure where payment was taken but no CV was generated, please contact us
              at <a href="mailto:support@resumify.co.za">support@resumify.co.za</a> within 7 days
              and we will investigate and resolve the issue.
            </p>
          </section>

          <section>
            <h2>5. Your Data and Privacy</h2>
            <p>
              By uploading your CV and job description, you grant Resumify a temporary, limited
              licence to process that content for the sole purpose of generating your tailored CV.
            </p>
            <p>
              We do not permanently store the content of your CV or job description on our servers.
              Uploaded files are processed and deleted after your session ends.
            </p>
            <p>
              We store your email address and usage count for the purpose of managing your free
              tier eligibility. We do not sell or share your personal information with third parties,
              except as required to process payments via PayFast.
            </p>
            <p>
              By using Resumify, you consent to the processing of your personal information as
              described above, in accordance with the Protection of Personal Information Act (POPIA).
            </p>
          </section>

          <section>
            <h2>6. Acceptable Use</h2>
            <p>You agree not to:</p>
            <ul>
              <li>Use Resumify to create fraudulent or misleading CVs</li>
              <li>Attempt to circumvent the email verification or payment systems</li>
              <li>Upload content that infringes the intellectual property rights of others</li>
              <li>Use automated scripts or bots to access the service</li>
              <li>Attempt to reverse-engineer or copy the service</li>
            </ul>
          </section>

          <section>
            <h2>7. Intellectual Property</h2>
            <p>
              The content of your original CV remains your intellectual property at all times.
              The tailored CV produced by Resumify, based on your original content, is also
              your property once downloaded.
            </p>
            <p>
              The Resumify brand, website, software, and AI prompts are the intellectual property
              of Mogomotsi Morwa and may not be copied, reproduced, or distributed without
              written permission.
            </p>
          </section>

          <section>
            <h2>8. Disclaimer of Warranties</h2>
            <p>
              Resumify provides its service on an "as is" basis. While we strive to produce
              high-quality tailored CVs, we do not guarantee that use of our service will result
              in employment, interview invitations, or any other specific outcome.
            </p>
            <p>
              We do not warrant that the service will be uninterrupted, error-free, or that
              any defects will be corrected. The service may be temporarily unavailable due to
              maintenance or factors beyond our control.
            </p>
          </section>

          <section>
            <h2>9. Limitation of Liability</h2>
            <p>
              To the fullest extent permitted by South African law, Resumify shall not be liable
              for any indirect, incidental, special, or consequential damages arising from your
              use of the service, including but not limited to loss of employment opportunity,
              loss of income, or reputational damage.
            </p>
            <p>
              Our total liability to you for any claim arising from use of the service shall not
              exceed the amount you paid for the specific transaction giving rise to the claim.
            </p>
          </section>

          <section>
            <h2>10. Governing Law</h2>
            <p>
              These Terms and Conditions are governed by and construed in accordance with the
              laws of the Republic of South Africa. Any disputes shall be subject to the
              jurisdiction of the South African courts.
            </p>
          </section>

          <section>
            <h2>11. Changes to These Terms</h2>
            <p>
              We reserve the right to update these Terms and Conditions at any time. Changes
              will be posted on this page with an updated date. Continued use of the service
              after changes constitutes acceptance of the new terms.
            </p>
          </section>

          <section>
            <h2>12. Contact Us</h2>
            <p>
              If you have any questions about these Terms and Conditions, please contact us:
            </p>
            <ul>
              <li>Email: <a href="mailto:support@resumify.co.za">support@resumify.co.za</a></li>
              <li>Website: <a href="https://www.resumify.co.za">www.resumify.co.za</a></li>
            </ul>
          </section>

        </div>

        <div style={{ marginTop: 40, paddingTop: 24, borderTop: '1px solid var(--border)' }}>
          <button className="page-btn-secondary" onClick={() => navigate('/')}>
            ← Back to Resumify
          </button>
        </div>

      </div>
    </div>
  );
}
